import React from 'react';
import reduxFetch from 'react-redux-fetch';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { getErrorCodeConvertor } from '../../app/lib/errorCodeConvertor';
import apiRoutes from '../../../app/api/routes';

export default ComposedComponent =>
  compose(
    withTranslation(),
    reduxFetch(props => [
      {
        resource: 'accessRight',
        method: 'get',
        request: accessRightId => ({
          url: apiRoutes.accessRight(accessRightId),
          meta: {
            toaster: {
              onErrorMessage: getErrorCodeConvertor(props.t, 'accessRightFetchErr'),
            },
          },
        }),
      },
    ])
  )(props => <ComposedComponent {...props} />);
